const cyrillicToLatin = {
  а: "a",
  б: "b",
  в: "v",
  г: "g",
  д: "d",
  ѓ: "gj",
  е: "e",
  ж: "z",
  з: "z",
  ѕ: "dz",
  и: "i",
  ј: "j",
  к: "k",
  л: "l",
  љ: "lj",
  м: "m",
  н: "n",
  њ: "nj",
  о: "o",
  п: "p",
  р: "r",
  с: "s",
  т: "t",
  ќ: "kj",
  у: "u",
  ф: "f",
  х: "h",
  ц: "c",
  ч: "c",
  џ: "dz",
  ш: "s",
};

const createProductSlug = (value) =>
  Array.from(String(value || "").toLowerCase())
    .map((character) => cyrillicToLatin[character] || character)
    .join("")
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

export const getProductSlug = (product) =>
  createProductSlug(product?.slug || product?.title);

export const getPhoneUrl = (product) =>
  `/telefon/${getProductSlug(product)}`;

export const getAccessoryUrl = (product) =>
  `/dodatok/${getProductSlug(product)}`;

export const getProductUrl = (product) => {
  const category = Array.isArray(product?.categories)
    ? product.categories[0]
    : product?.categories;

  return category === "telefoni" ? getPhoneUrl(product) : getAccessoryUrl(product);
};
